module.exports = __webpack_public_path__ + "img/check-off-disabled.2b675501.svg";